import { ActionType, IAssetActionPayloadModel, IAssetModel } from "@xala/common-services";
import { IFormValues } from "@xala/common-ui";

function toPayloadNumber(value: unknown): number {
  if (value === undefined || value === null || value === "") {
    return 0;
  }
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

function str(value: unknown): string {
  return typeof value === "string" ? value : "";
}

/**
 * Only the payload fields relevant to the selected action type (new API names).
 */
function buildActionPayload(
  actionType: ActionType,
  values: IFormValues
): IAssetActionPayloadModel | undefined {
  switch (actionType) {
    case ActionType.OpenUrl:
      return { Url: str(values.Url).trim() };
    case ActionType.OpenScreen:
      return {
        ScreenId: toPayloadNumber(values.ScreenId),
        ScreenName: str(values.ScreenName).trim(),
        ScreenTypeCode: str(values.ScreenType).trim(),
      };
    case ActionType.OpenMedia:
      return {
        MediaId: toPayloadNumber(values.AssetId),
        MediaName: str(values.AssetTitle).trim(),
      };
    case ActionType.OpenMediaCollection:
      return {
        MediaCollectionId: toPayloadNumber(values.CollactionId),
        MediaCollectionName: str(values.CollectionName).trim(),
      };
    case ActionType.NoAction:
    case ActionType.CallTo:
    case ActionType.EmailTo:
      return undefined;
    default:
      return undefined;
  }
}

/**
 * Builds the asset PUT body: `IsTitleHidden` (from current asset) and `Action` with a type-specific `Payload`.
 */
export function buildAssetUpdateWithAction(
  asset: IAssetModel,
  actionType: ActionType,
  values: IFormValues
): IAssetModel {
  const payload = buildActionPayload(actionType, values);

  return {
    ...asset,
    IsTitleHidden: Boolean(asset.IsTitleHidden),
    Action: {
      Type: actionType,
      ...(payload ? { Payload: payload } : {}),
    },
  };
}
